// extracted by mini-css-extract-plugin
export default {"InfluencerProfile_details_scoialCard":"SocialMediaTag_InfluencerProfile_details_scoialCard__WGer0"};